module.exports = __webpack_public_path__ + "img/2X.1.4ae6a185.jpg";